import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {switchMap, tap} from "rxjs/operators";
import {ManagerV3RestService} from "../../../services/rest/v3/manager-rest.service";
import {V3Manager, V3School} from "../../../model/v3/schools";
import {ManagerUtils} from "../../../services/utils/v3/manager-utils";
import {Page, Pageable} from "../../../model/rest/base";

@Component({
    selector: 'app-managers-block',
    templateUrl: './managers-block.component.html',
    styleUrls: ['./managers-block.component.css'],
    standalone: false
})
export class ManagersBlockComponent implements OnInit {
  mSchool: V3School;
  managers: Page<V3Manager>;
  pageable = new Pageable(0, 5, null);

  @Input()
  set school(value: V3School) {
    this.mSchool = value;
    this.reload();
  }
  @Output() redirectEmitter: EventEmitter<string> = new EventEmitter();

  constructor(
    private managerV3Rest: ManagerV3RestService
  ) { }

  ngOnInit() {
  }

  private reload() {
    if (!this.mSchool) return;
    this.loadManagers(this.pageable)
      .subscribe();
  }

  loadManagers(pageable: Pageable) {
    return this.managerV3Rest.findManagers(this.mSchool.id, pageable).pipe(
      tap(managers => this.managers = managers)
    )
  }

  getName(manager: V3Manager) {
    return ManagerUtils.getName(manager.person)
  }

  getMail(manager: V3Manager) {
    return manager.person.registrationEmail;
  }

  getManagersLength() {
    return this.managers.totalElements
  }

  isEmpty() {
    return this.managers.empty;
  }

  delete(manager: V3Manager) {
    this.managerV3Rest.deleteManager(this.mSchool.id, manager.id).pipe(
      switchMap(_ => this.loadManagers(this.pageable)),
    ).subscribe();
  }

  redirectTo(path: string) {
    this.redirectEmitter.emit(path);
  }
}
